import { render } from "./OptionboardPhonemicVowel.vue?vue&type=template&id=390e2394&scoped=true"
import script from "./OptionboardPhonemicVowel.vue?vue&type=script&lang=js"
export * from "./OptionboardPhonemicVowel.vue?vue&type=script&lang=js"

import "@/css/components/optionboard-phonemic-vowel.css?vue&type=style&index=0&id=390e2394&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-390e2394"]])

export default __exports__